module.exports = __webpack_public_path__ + "fonts/NeulisAlt-Bold.488b8a2.woff";